export default "/react/logoGudok-347e33db.png";